import React from 'react';
import { Shield, Lock, Eye, UserCheck } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Privacidad = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 flex items-center gap-3">
            <Lock className="h-12 w-12" />
            Política de Privacidad
          </h1>
          <p className="text-xl opacity-90">En Mora BioVet respetamos y protegemos la información de nuestros clientes</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <Eye className="h-6 w-6 text-[#84cc16]" />
              1. Información que recopilamos
            </h2>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Datos del propietario</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Información del paciente (mascota)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Datos de contacto</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">2. Uso de la información</h2>
            <p className="text-gray-700 mb-4">La información se utiliza para:</p>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Procesar estudios de laboratorio</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Entregar resultados</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Brindar atención al cliente</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Mejorar nuestros servicios</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <Shield className="h-6 w-6 text-[#84cc16]" />
              3. Protección de datos
            </h2>
            <p className="text-gray-700">
              Implementamos medidas de seguridad para proteger la información contra accesos no autorizados.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">4. Compartición de información</h2>
            <p className="text-gray-700">
              No compartimos datos personales con terceros, salvo requerimiento legal o autorización del usuario.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6 bg-gradient-to-br from-green-50 to-white">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <UserCheck className="h-6 w-6 text-[#84cc16]" />
              5. Derechos del usuario
            </h2>
            <p className="text-gray-700 mb-4">El usuario puede solicitar:</p>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="font-semibold text-[#1e3a8a]">Acceso</p>
                <p className="text-sm text-gray-600">A sus datos personales</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="font-semibold text-[#1e3a8a]">Rectificación</p>
                <p className="text-sm text-gray-600">De datos incorrectos</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="font-semibold text-[#1e3a8a]">Cancelación</p>
                <p className="text-sm text-gray-600">De sus datos</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <p className="font-semibold text-[#1e3a8a]">Oposición</p>
                <p className="text-sm text-gray-600">Al tratamiento (ARCO)</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="bg-blue-50 border-l-4 border-[#1e40af] p-6 rounded-lg mt-8">
          <p className="text-gray-700 font-semibold mb-2">
            Para ejercer sus derechos ARCO:
          </p>
          <p className="text-gray-600">
            Envía un correo a: <a href="mailto:info@morabiovet.com" className="text-[#1e40af] hover:underline">info@morabiovet.com</a>
          </p>
          <p className="text-gray-600 mt-4 text-sm">
            <strong>Última actualización:</strong> Marzo 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacidad;